import React, { SVGProps } from 'react';

const DocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.35 2.25H4.94998C4.59193 2.25 4.24856 2.39223 3.99538 2.64541C3.74221 2.89858 3.59998 3.24196 3.59998 3.6V14.4C3.59998 14.758 3.74221 15.1014 3.99538 15.3546C4.24856 15.6078 4.59193 15.75 4.94998 15.75H13.05C13.408 15.75 13.7514 15.6078 14.0046 15.3546C14.2577 15.1014 14.4 14.758 14.4 14.4V6.3L10.35 2.25Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.35 2.25V6.3H14.4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7 9.67499H6.29999"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7 12.375H6.29999"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.64999 6.97501H6.97499H6.29999"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocumentIcon;
